import { cachedFetch } from './cached-fetch'
import { requestDebouncer } from './request-debouncer'

/**
 * Cache yardımcı fonksiyonları
 */
export const cacheHelpers = {
  cachedFetch,
  requestDebouncer
}

export {
  cachedFetch,
  requestDebouncer
}